module.exports = __webpack_public_path__ + "static/media/gift1.af911bda.webp";